module.exports = __webpack_public_path__ + "static/media/Sprint-Retro-3-Audio-2.a1d083a4.mp3";